import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';

import { TextBlock } from '../styles/TextBlock';

function SectionNuCommunity({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Section
      backgroundColor="#2c1c25"
      backgroundImageUrl={{
        xs: {
          '1x': 'nucommunity/nucommunity-xs@1x.jpg',
          '2x': 'nucommunity/nucommunity-xs@2x.jpg',
          '3x': 'nucommunity/nucommunity-xs@3x.jpg',
        },
        md: {
          '1x': 'nucommunity/nucommunity-md@1x.jpg',
          '2x': 'nucommunity/nucommunity-md@2x.jpg',
          '3x': 'nucommunity/nucommunity-md@3x.jpg',
        },
        lg: {
          '1x': 'nucommunity/nucommunity-lg@1x.jpg',
          '2x': 'nucommunity/nucommunity-lg@2x.jpg',
          '3x': 'nucommunity/nucommunity-lg@3x.jpg',
        },
      }}
    >
      <TextBlock>
        <Typography
          variant="title"
          color="white"
          gutterBottom={2}
          intlKey={`cms.homePage.homeCardsArea.${index}.cardPreTitleText`}
        />

        <Typography
          variant="title"
          tag="p"
          color="white"
          gutterBottom={2}
          intlKey={`cms.homePage.homeCardsArea.${index}.cardTitle`}
          whiteSpace="pre-line"
        />

        <Link
          href={formatMessage({ id: `cms.homePage.homeCardsArea.${index}.cardCtaLink` })}
          variant="action"
          color="white"
          intlKey={`cms.homePage.homeCardsArea.${index}.cardCtaText`}
        />
      </TextBlock>
    </Section>
  );
}

SectionNuCommunity.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionNuCommunity);
